'use client';

import { Grid, GridItem, Skeleton } from '@chakra-ui/react';

const ProductGridSkeleton = () => {
  const _mobileGrid = (
    <Grid
      templateColumns="repeat(2, 1fr)"
      columnGap={{ base: '0.75rem', xl: '1.25rem' }}
      rowGap={{ base: '1.25rem', xl: '1rem' }}
      w="100%"
      position="relative"
      display={{ base: 'grid', lg: 'none' }}
    >
      {Array.apply(null, Array(4)).map((_, idx) => (
        <GridItem key={`ske_${idx}`}>
          <Skeleton w="100%" h="19.5rem" />
        </GridItem>
      ))}
    </Grid>
  );

  const _desktopGrid = (
    <Grid
      templateColumns="repeat(4, 1fr)"
      columnGap={{ base: '0.75rem', xl: '1.25rem' }}
      rowGap={{ base: '1.25rem', xl: '1rem' }}
      w="100%"
      position="relative"
      display={{ base: 'none', lg: 'grid' }}
    >
      {Array.apply(null, Array(8)).map((_, idx) => (
        <GridItem key={`ske_${idx}`}>
          <Skeleton w="100%" h="30.625rem" />
        </GridItem>
      ))}
    </Grid>
  );

  return (
    <>
      {_mobileGrid}
      {_desktopGrid}
    </>
  );
};

export default ProductGridSkeleton;
